import React from 'react';
import PropTypes from 'prop-types';
import EventDescription from './EventDescription';
import { getWsInterface } from '~spa/Utils/Websockets.js';

/**
 * This file is a copy of client/src/shared/components/react/Scoreboard/Scoreboard.jsx
 * with minimal modifications to for use with the EventDescription component.
 * It is meant to be a temporary solution until Amber team implement a common sport widget
 * store as part AM-3927, at which point this Wrapper should not be needed.
 */
class EventDescriptionWrapper extends React.Component {
    constructor(props) {
        super(props);

        this.wsInterface = getWsInterface();
        this.connected = false;
        this.wsInplayHandler = null;

        this.getEventsSubscriptionList = this.getEventsSubscriptionList.bind(this);
        this.handleConnect = this.handleConnect.bind(this);
        this.handleUpdateEvents = this.handleUpdateEvents.bind(this);

        this.state = { event: props.event };
    }

    static propTypes = {
        event: PropTypes.object.isRequired,
        hasBoostedOddsSelections: PropTypes.bool,
    };

    componentDidMount() {
        if (!this.wsInplayHandler) {
            this.wsInplayHandler = this.wsInterface.requestHandler('mainSocket');
        }

        if (this.wsInplayHandler) {
            this.wsInplayHandler.onConnection(this.handleConnect, true);
        }
    }

    getEventsSubscriptionList() {
        try {
            const markets = Object.keys(this.props.event.markets);

            return [{
                event_id: parseInt(this.props.event.id, 10),
                market_id: parseInt(markets[0], 10),
            }];
        } catch (e) {
            return [];
        }
    }

    handleConnect() {
        this.connected = true;
        this.wsInplayHandler.subscribe(this.getEventsSubscriptionList());
        this.connected = true;
        this.handleUpdate();
    }

    handleUpdate() {
        // these handlers don't get unregistered when the component unmounts
        // this also happens in react/Scoreboard/Scoreboard.jsx (which this file is a copy of).
        // It is a known issue that should get fixed in AM-2540
        this.wsInplayHandler.registerHandler('inplay_update', this.handleUpdateEvents);
        this.wsInplayHandler.registerHandler('price_update', this.handleUpdateEvents);
    }

    handleUpdateEvents(msg) {
        msg.events.forEach((ev) => {
            if (this.props.event.id === ev.id) {
                this.setState(({event: previousEventState}) => ({
                    event: {
                        ...previousEventState,
                        ...ev,
                    },
                }));
            }
        });
    }

    componentWillUnmount () {
        this.wsInplayHandler.unsubscribe(this.getEventsSubscriptionList());
    }

    render() {
        return (
            <EventDescription
                { ...this.props }
                event={this.state.event}
            />
        );
    }
}

export default EventDescriptionWrapper;
